import Icon from "../Icons/Icon";

interface SwitchBadgeProps {
  status: boolean;
}

export default function SwitchBadge({ status }: SwitchBadgeProps) {
  return status ? <Icon name="check" color="#00A355" /> : <Icon name="cross" color="#D10707" />;
}
